import { TYPO } from "styles/Typo";

function VoteTitle({ detailDiscussData }: { detailDiscussData: any }) {
  return (
    <h3
      className={`${TYPO.TYPO6_RG} text-gray80  break-keep whitespace-pre-line  break-words text-center`}
      data-testid="discuss-title"
    >
      {detailDiscussData?.vote_title || detailDiscussData?.title}
    </h3>
  );
}

export default VoteTitle;
